module.exports = __webpack_public_path__ + "static/media/riskAddUp.a5ffd1bd.mp3";